const MelodyType = Object.freeze ({
    FREE: 'FREE',
    ASCENDING: 'ASCENDING',
    DESCENDING: 'DESCENDING'
})

export default MelodyType